module.exports = __webpack_public_path__ + "static/media/aipimlanche.c12b085b.webp";